import { FC, useRef, useEffect, useState } from 'react';
import { shallowEqual, useSelector, connect, useDispatch, ConnectedProps } from 'react-redux';
import { LayoutSplashScreen } from '../../../../_metronic/layout/core';
import * as auth from './AuthRedux';
import { getUserByToken } from './AuthCRUD';
import { RootState } from '../../../../setup';

const mapState = (state: RootState) => ({ auth: state.auth });
const connector = connect(mapState, auth.actions);
type PropsFromRedux = ConnectedProps<typeof connector>;

const AuthInit: FC<PropsFromRedux> = (props) => {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const accessToken = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual);

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        console.log('Starting user request...');
        if (!didRequest.current) {
          console.log('Did not request before, proceeding...');
          
          const { data: user } = await getUserByToken();
          console.log('User data received:', user);
          
          dispatch(props.fulfillUser(user));
          console.log('User dispatched to Redux store.');
        } else {
          console.log('Request has already been made.');
        }
      } catch (error) {
        console.error('Error occurred during user request:', error);
        if (!didRequest.current) {
          dispatch(props.logout());
          console.log('User logged out due to error.');
        }
      } finally {
        setShowSplashScreen(false);
        console.log('Splash screen hidden.');
      }

      return () => {
        didRequest.current = true;
        console.log('didRequest set to true.');
      };
    };

    console.log('Access token3:', accessToken);
    if (accessToken) {
      requestUser();
    } else {
      dispatch(props.logout());
      setShowSplashScreen(false);
      console.log('No access token, user logged out.');
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
};

export default connector(AuthInit);
